const PaymentMethods = {
  paymentMethodPath: (id: string) => `/api/payment_methods/${id}`,
  paymentMethodsPath: () => `/api/payment_methods`,
};

export default PaymentMethods;
